import { CALL_API } from '../middleware/ApiMiddleware';

export const SHAPEFILE_CREATE_REQUEST = 'SHAPEFILE_CREATE_REQUEST';
export const SHAPEFILE_CREATE_SUCCESS = 'SHAPEFILE_CREATE_SUCCESS';
export const SHAPEFILE_CREATE_FAILURE = 'SHAPEFILE_CREATE_FAILURE';

export const SHAPEFILE_NAME_FETCH_REQUEST = 'SHAPEFILE_NAME_FETCH_REQUEST';
export const SHAPEFILE_NAME_FETCH_SUCCESS = 'SHAPEFILE_NAME_FETCH_SUCCESS';
export const SHAPEFILE_NAME_FETCH_FAILURE = 'SHAPEFILE_NAME_FETCH_FAILURE';

export const MAP_SETTINGS_FETCH_REQUEST = 'MAP_SETTINGS_FETCH_REQUEST';
export const MAP_SETTINGS_FETCH_SUCCESS = 'MAP_SETTINGS_FETCH_SUCCESS';
export const MAP_SETTINGS_FETCH_FAILURE = 'MAP_SETTINGS_FETCH_FAILURE';

export const MAP_SETTINGS_EDIT_REQUEST = 'MAP_SETTINGS_EDIT_REQUEST';
export const MAP_SETTINGS_EDIT_SUCCESS = 'MAP_SETTINGS_EDIT_SUCCESS';
export const MAP_SETTINGS_EDIT_FAILURE = 'MAP_SETTINGS_EDIT_FAILURE';

export const AGENCY_MAP_LAYER_FETCH_REQUEST = 'AGENCY_MAP_LAYER_FETCH_REQUEST';
export const AGENCY_MAP_LAYER_FETCH_SUCCESS = 'AGENCY_MAP_LAYER_FETCH_SUCCESS';
export const AGENCY_MAP_LAYER_FETCH_FAILURE = 'AGENCY_MAP_LAYER_FETCH_FAILURE';

export const AGENCY_MAP_LAYER_EDIT_REQUEST = 'AGENCY_MAP_LAYER_EDIT_REQUEST';
export const AGENCY_MAP_LAYER_EDIT_SUCCESS = 'AGENCY_MAP_LAYER_EDIT_SUCCESS';
export const AGENCY_MAP_LAYER_EDIT_FAILURE = 'AGENCY_MAP_LAYER_EDIT_FAILURE';

export const AGENCY_PARCEL_FILE_FETCH_REQUEST = 'AGENCY_PARCEL_FILE_FETCH_REQUEST';
export const AGENCY_PARCEL_FILE_FETCH_SUCCESS = 'AGENCY_PARCEL_FILE_FETCH_SUCCESS';
export const AGENCY_PARCEL_FILE_FETCH_FAILURE = 'AGENCY_PARCEL_FILE_FETCH_FAILURE';

export const AGENCY_PARCEL_FILE_EDIT_REQUEST = 'AGENCY_PARCEL_FILE_EDIT_REQUEST';
export const AGENCY_PARCEL_FILE_EDIT_SUCCESS = 'AGENCY_PARCEL_FILE_EDIT_SUCCESS';
export const AGENCY_PARCEL_FILE_EDIT_FAILURE = 'AGENCY_PARCEL_FILE_EDIT_FAILURE';

export const KML_LIST_FETCH_REQUEST = 'KML_LIST_FETCH_REQUEST';
export const KML_LIST_FETCH_SUCCESS = 'KML_LIST_FETCH_SUCCESS';
export const KML_LIST_FETCH_FAILURE = 'KML_LIST_FETCH_FAILURE';

export const KML_FETCH_REQUEST = 'KML_FETCH_REQUEST';
export const KML_FETCH_SUCCESS = 'KML_FETCH_SUCCESS';
export const KML_FETCH_FAILURE = 'KML_FETCH_FAILURE';

export const KML_EDIT_REQUEST = 'KML_EDIT_REQUEST';
export const KML_EDIT_SUCCESS = 'KML_EDIT_SUCCESS';
export const KML_EDIT_FAILURE = 'KML_EDIT_FAILURE';

export const KML_CREATE_REQUEST = 'KML_CREATE_REQUEST';
export const KML_CREATE_SUCCESS = 'KML_CREATE_SUCCESS';
export const KML_CREATE_FAILURE = 'KML_CREATE_FAILURE';

export const KML_DELETE_REQUEST = 'KML_DELETE_REQUEST';
export const KML_DELETE_SUCCESS = 'KML_DELETE_SUCCESS';
export const KML_DELETE_FAILURE = 'KML_DELETE_FAILURE';

export const KML_LIST_EDIT_SEQUENCE_REQUEST = 'KML_LIST_EDIT_SEQUENCE_REQUEST';
export const KML_LIST_EDIT_SEQUENCE_SUCCESS = 'KML_LIST_EDIT_SEQUENCE_SUCCESS';
export const KML_LIST_EDIT_SEQUENCE_FAILURE = 'KML_LIST_EDIT_SEQUENCE_FAILURE';

export const MAP_CONFIG_FETCH_REQUEST = 'MAP_CONFIG_FETCH_REQUEST';
export const MAP_CONFIG_FETCH_SUCCESS = 'MAP_CONFIG_FETCH_SUCCESS';
export const MAP_CONFIG_FETCH_FAILURE = 'MAP_CONFIG_FETCH_FAILURE';

export const AGENCY_BOUNDARY_CREATE_REQUEST = 'AGENCY_BOUNDARY_CREATE_REQUEST';
export const AGENCY_BOUNDARY_CREATE_SUCCESS = 'AGENCY_BOUNDARY_CREATE_SUCCESS';
export const AGENCY_BOUNDARY_CREATE_FAILURE = 'AGENCY_BOUNDARY_CREATE_FAILURE';

export const AGENCY_BOUNDARY_NAME_FETCH_REQUEST = 'AGENCY_BOUNDARY_NAME_FETCH_REQUEST';
export const AGENCY_BOUNDARY_NAME_FETCH_SUCCESS = 'AGENCY_BOUNDARY_NAME_FETCH_SUCCESS';
export const AGENCY_BOUNDARY_NAME_FETCH_FAILURE = 'AGENCY_BOUNDARY_NAME_FETCH_FAILURE';

export const PARCEL_FIELD_LIST_FETCH_REQUEST = 'PARCEL_FIELD_LIST_FETCH_REQUEST';
export const PARCEL_FIELD_LIST_FETCH_SUCCESS = 'PARCEL_FIELD_LIST_FETCH_SUCCESS';
export const PARCEL_FIELD_LIST_FETCH_FAILURE = 'PARCEL_FIELD_LIST_FETCH_FAILURE';

export const ALL_PARCEL_FIELD_LIST_FETCH_REQUEST = 'ALL_PARCEL_FIELD_LIST_FETCH_REQUEST';
export const ALL_PARCEL_FIELD_LIST_FETCH_SUCCESS = 'ALL_PARCEL_FIELD_LIST_FETCH_SUCCESS';
export const ALL_PARCEL_FIELD_LIST_FETCH_FAILURE = 'ALL_PARCEL_FIELD_LIST_FETCH_FAILURE';

export const PARCEL_SEARCH_REQUEST = 'PARCEL_SEARCH_REQUEST';
export const PARCEL_SEARCH_SUCCESS = 'PARCEL_SEARCH_SUCCESS';
export const PARCEL_SEARCH_FAILURE = 'PARCEL_SEARCH_FAILURE';

export const GET_LOCATION_REQUEST = 'GET_LOCATION_REQUEST';
export const GET_LOCATION_SUCCESS = 'GET_LOCATION_SUCCESS';
export const GET_LOCATION_FAILURE = 'GET_LOCATION_FAILURE';

export const GET_SECURE_LOCATION_SETTINGS_REQUEST = 'GET_SECURE_LOCATION_SETTINGS_REQUEST';
export const GET_SECURE_LOCATION_SETTINGS_SUCCESS = 'GET_SECURE_LOCATION_SETTINGS_SUCCESS';
export const GET_SECURE_LOCATION_SETTINGS_FAILURE = 'GET_SECURE_LOCATION_SETTINGS_FAILURE';

export const UPDATE_SECURE_LOCATION_SETTINGS_REQUEST = 'UPDATE_SECURE_LOCATION_SETTINGS_REQUEST';
export const UPDATE_SECURE_LOCATION_SETTINGS_SUCCESS = 'UPDATE_SECURE_LOCATION_SETTINGS_SUCCESS';
export const UPDATE_SECURE_LOCATION_SETTINGS_FAILURE = 'UPDATE_SECURE_LOCATION_SETTINGS_FAILURE';

export const FETCH_CONFIG_GIS_FIELDS_REQUEST = 'FETCH_CONFIG_GIS_FIELDS_REQUEST';
export const FETCH_CONFIG_GIS_FIELDS_SUCCESS = 'FETCH_CONFIG_GIS_FIELDS_SUCCESS';
export const FETCH_CONFIG_GIS_FIELDS_FAILURE = 'FETCH_CONFIG_GIS_FIELDS_FAILURE';

export const FETCH_CONFIG_GIS_MAPPING_REQUEST = 'FETCH_CONFIG_GIS_MAPPING_REQUEST';
export const FETCH_CONFIG_GIS_MAPPING_SUCCESS = 'FETCH_CONFIG_GIS_MAPPING_SUCCESS';
export const FETCH_CONFIG_GIS_MAPPING_FAILURE = 'FETCH_CONFIG_GIS_MAPPING_FAILURE';

export const SAVE_CONFIG_GIS_MAPPING_REQUEST = 'SAVE_CONFIG_GIS_MAPPING_REQUEST';
export const SAVE_CONFIG_GIS_MAPPING_SUCCESS = 'SAVE_CONFIG_GIS_MAPPING_SUCCESS';
export const SAVE_CONFIG_GIS_MAPPING_FAILURE = 'SAVE_CONFIG_GIS_MAPPING_FAILURE';

export const PARCEL_CLEAR = 'PARCEL_ClEAR';
export const SET_PARCEL = 'SET_PARCEL';

const mapSettingsBaseURL = 'config/location/map-settings';
const agencyParcelFileBaseURL = 'config/gis/layers/parcel';
const kmlBaseURL = 'config/gis/kmls';
const cdbgBaseURL = 'admin/gis/layers/cdbg';
const agencyBoundaryBaseURL = 'config/gis/agency-boundary/kmls';
const parcelFieldsBaseURL = 'config/gis/parcel-fields';
const allParcelFieldsBaseURL = 'config/gis/agency-parcel-fields';
const casesParcelBaseURL = 'config/gis/parcels';
const casesLocationBaseURL = 'gis/reverse-geocode';

export const fetchShapeFileName = () => ({
  [CALL_API]: {
    endpoint: cdbgBaseURL,
    method: 'get',
    authenticated: true,
    types: [SHAPEFILE_NAME_FETCH_REQUEST, SHAPEFILE_NAME_FETCH_SUCCESS, SHAPEFILE_NAME_FETCH_FAILURE],
  },
});

export const createShapeFile = (fileURL: string) => ({
  [CALL_API]: {
    endpoint: cdbgBaseURL,
    method: 'post',
    body: { fileURL },
    authenticated: true,
    types: [SHAPEFILE_CREATE_REQUEST, SHAPEFILE_CREATE_SUCCESS, SHAPEFILE_CREATE_FAILURE],
  },
});

export const createMapLayer = (kmlFileDetails: IKMLFileDetailsRequest) => {
  const formData = new FormData();
  formData.append('kmlfile', kmlFileDetails.kmlfile);
  formData.append('label', kmlFileDetails.label);
  formData.append('isActive', kmlFileDetails.isActive.toString());
  formData.append('source', kmlFileDetails.source);
  formData.append('gisURL', kmlFileDetails.gisURL);

  return {
    [CALL_API]: {
      endpoint: `${kmlBaseURL}`,
      method: 'post',
      body: formData,
      authenticated: true,
      headers: { 'Content-Type': 'multipart/form-data' },
      types: [KML_CREATE_REQUEST, KML_CREATE_SUCCESS, KML_CREATE_FAILURE],
    },
  };
};

export const editMapLayer = (mapLayerId: number, kmlFileDetails: IKMLFileDetailsRequest) => {
  const formData = new FormData();
  formData.append('kmlfile', kmlFileDetails.kmlfile);
  formData.append('label', kmlFileDetails.label);
  formData.append('isActive', kmlFileDetails.isActive.toString());
  formData.append('source', kmlFileDetails.source);
  formData.append('gisURL', kmlFileDetails.gisURL);

  return {
    [CALL_API]: {
      endpoint: `${kmlBaseURL}/${mapLayerId}`,
      method: 'put',
      body: formData,
      authenticated: true,
      headers: { 'Content-Type': 'multipart/form-data' },
      types: [KML_EDIT_REQUEST, KML_EDIT_SUCCESS, KML_EDIT_FAILURE],
    },
  };
};

export const fetchMapLayer = (mapLayerId: number) => ({
  [CALL_API]: {
    endpoint: `${kmlBaseURL}/${mapLayerId}`,
    method: 'get',
    authenticated: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    types: [KML_FETCH_REQUEST, KML_FETCH_SUCCESS, KML_FETCH_FAILURE],
  },
});

export const fetchMapLayers = (params?: IFetchMapLayerParams) => ({
  [CALL_API]: {
    endpoint: `${kmlBaseURL}`,
    method: 'get',
    authenticated: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    params,
    types: [KML_LIST_FETCH_REQUEST, KML_LIST_FETCH_SUCCESS, KML_LIST_FETCH_FAILURE],
  },
});

export const fetchMapSettings = () => ({
  [CALL_API]: {
    endpoint: `${mapSettingsBaseURL}`,
    method: 'get',
    authenticated: true,
    types: [MAP_SETTINGS_FETCH_REQUEST, MAP_SETTINGS_FETCH_SUCCESS, MAP_SETTINGS_FETCH_FAILURE],
  },
});

export const updateMapSettings = (agencyMapSettings: IAgencyMapSettings) => ({
  [CALL_API]: {
    endpoint: `${mapSettingsBaseURL}`,
    method: 'put',
    body: agencyMapSettings,
    authenticated: true,
    types: [MAP_SETTINGS_EDIT_REQUEST, MAP_SETTINGS_EDIT_SUCCESS, MAP_SETTINGS_EDIT_FAILURE],
  },
});

export const editMapLayerSequence = (sequence: number[]) => ({
  [CALL_API]: {
    endpoint: `${kmlBaseURL}/sequence`,
    method: 'put',
    body: { sequence },
    authenticated: true,
    types: [KML_LIST_EDIT_SEQUENCE_REQUEST, KML_LIST_EDIT_SEQUENCE_SUCCESS, KML_LIST_EDIT_SEQUENCE_FAILURE],
  },
});

export const fetchAgencyParcelLayer = () => ({
  [CALL_API]: {
    endpoint: `${agencyParcelFileBaseURL}`,
    method: 'get',
    authenticated: true,
    types: [AGENCY_MAP_LAYER_FETCH_REQUEST, AGENCY_MAP_LAYER_FETCH_SUCCESS, AGENCY_MAP_LAYER_FETCH_FAILURE],
  },
});

export const updateAgencyParcelLayer = (fileURL: string) => ({
  [CALL_API]: {
    endpoint: agencyParcelFileBaseURL,
    method: 'post',
    body: { fileURL },
    authenticated: true,
    types: [AGENCY_MAP_LAYER_EDIT_REQUEST, AGENCY_MAP_LAYER_EDIT_SUCCESS, AGENCY_MAP_LAYER_EDIT_FAILURE],
    hideLoadingWidget: true,
    hideDefaultAlert: true,
  },
});

export const deleteMapLayer = (mapLayerId: number) => ({
  [CALL_API]: {
    endpoint: `${kmlBaseURL}/${mapLayerId}`,
    method: 'delete',
    authenticated: true,
    types: [KML_DELETE_REQUEST, KML_DELETE_SUCCESS, KML_DELETE_FAILURE],
  },
});

export const fetchMapConfig = () => ({
  [CALL_API]: {
    endpoint: 'config/gis/layers/map-config',
    method: 'get',
    authenticated: true,
    types: [MAP_CONFIG_FETCH_REQUEST, MAP_CONFIG_FETCH_SUCCESS, MAP_CONFIG_FETCH_FAILURE],
  },
});

export const fetchAgencyBoundaryFileName = () => ({
  [CALL_API]: {
    endpoint: agencyBoundaryBaseURL,
    method: 'get',
    authenticated: true,
    types: [AGENCY_BOUNDARY_NAME_FETCH_REQUEST, AGENCY_BOUNDARY_NAME_FETCH_SUCCESS, AGENCY_BOUNDARY_NAME_FETCH_FAILURE],
  },
});

export const createAgencyBoundary = (fileURL: string) => ({
  [CALL_API]: {
    endpoint: agencyBoundaryBaseURL,
    method: 'post',
    body: { fileURL },
    authenticated: true,
    types: [AGENCY_BOUNDARY_CREATE_REQUEST, AGENCY_BOUNDARY_CREATE_SUCCESS, AGENCY_BOUNDARY_CREATE_FAILURE],
    hideLoadingWidget: true,
  },
});

export const fetchParcelFields = (params?: IFetchParcelFieldsParams) => ({
  [CALL_API]: {
    endpoint: parcelFieldsBaseURL,
    method: 'get',
    authenticated: true,
    params,
    types: [PARCEL_FIELD_LIST_FETCH_REQUEST, PARCEL_FIELD_LIST_FETCH_SUCCESS, PARCEL_FIELD_LIST_FETCH_FAILURE],
  },
});

export const fetchAllParcelFields = () => ({
  [CALL_API]: {
    endpoint: allParcelFieldsBaseURL,
    method: 'get',
    authenticated: true,
    types: [
      ALL_PARCEL_FIELD_LIST_FETCH_REQUEST,
      ALL_PARCEL_FIELD_LIST_FETCH_SUCCESS,
      ALL_PARCEL_FIELD_LIST_FETCH_FAILURE,
    ],
  },
});

let parcelRequestSequence = 0;

export const getParcel = (parcelDetails: any, hideLoadingWidget = false, uniqueIdentifier?: string) => {
  const requestIdentifier = uniqueIdentifier || `parcel-${Date.now()}-${++parcelRequestSequence}`;

  return {
    [CALL_API]: {
      endpoint: casesParcelBaseURL,
      method: 'get',
      authenticated: true,
      params: parcelDetails,
      hideLoadingWidget,
      uniqueIdentifier: requestIdentifier,
      types: [PARCEL_SEARCH_REQUEST, PARCEL_SEARCH_SUCCESS, PARCEL_SEARCH_FAILURE],
    },
  };
};

export const getLocation = (parcelDetails: ILocationCoordinatesRequest) => ({
  [CALL_API]: {
    endpoint: casesLocationBaseURL,
    method: 'get',
    authenticated: true,
    params: parcelDetails,
    types: [GET_LOCATION_REQUEST, GET_LOCATION_SUCCESS, GET_LOCATION_FAILURE],
  },
});

export const setParcel = (parcel: IParcel | null) => ({
  type: SET_PARCEL,
  response: parcel,
});

// TODO: verify if needed, else remove.
export const LOCATION_SEARCH_REQUEST = 'LOCATION_SEARCH_REQUEST';
export const LOCATION_SEARCH_SUCCESS = 'LOCATION_SEARCH_SUCCESS';
export const LOCATION_SEARCH_FAILURE = 'LOCATION_SEARCH_FAILURE';
export const LOCATION_SEARCH_CLEAR = 'LOCATION_SEARCH_CLEAR';

export const CUSTOM_FIELD_GIS_CREATE_REQUEST = 'CUSTOM_FIELD_GIS_CREATE_REQUEST';
export const CUSTOM_FIELD_GIS_CREATE_SUCCESS = 'CUSTOM_FIELD_GIS_CREATE_SUCCESS';
export const CUSTOM_FIELD_GIS_CREATE_FAILURE = 'CUSTOM_FIELD_GIS_CREATE_FAILURE';

export const searchLocation = (
  q: string,
  bbox: number[],
  hideLoadingWidget: boolean = false,
  long?: number,
  lat?: number,
  uniqueIdentifier?: string,
  hideDefaultAlert?: boolean,
  abortSignal: AbortSignal = null
) => {
  const params = {
    ...(q && { q }),
    ...(bbox && { bbox }),
    ...(long && { long }),
    ...(lat && { lat }),
  };

  return {
    [CALL_API]: {
      endpoint: 'xerce/location/search',
      method: 'get',
      authenticated: true,
      params,
      types: [LOCATION_SEARCH_REQUEST, LOCATION_SEARCH_SUCCESS, LOCATION_SEARCH_FAILURE],
      hideLoadingWidget,
      uniqueIdentifier,
      hideDefaultAlert,
      abortSignal,
    },
  };
};

export const clearSearchLocation = () => ({
  type: LOCATION_SEARCH_CLEAR,
});

export const clearParcel = () => ({
  type: PARCEL_CLEAR,
});

export const createCustomFieldGis = (agencyID: number, customFieldGis: any) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyID}/gis/location-fields`,
    method: 'post',
    body: customFieldGis,
    authenticated: true,
    types: [CUSTOM_FIELD_GIS_CREATE_REQUEST, CUSTOM_FIELD_GIS_CREATE_SUCCESS, CUSTOM_FIELD_GIS_CREATE_FAILURE],
  },
});

export const fetchSecuredLocationSettings = () => ({
  [CALL_API]: {
    endpoint: 'config/gis/secured-location-settings',
    method: 'get',
    authenticated: true,
    types: [
      GET_SECURE_LOCATION_SETTINGS_REQUEST,
      GET_SECURE_LOCATION_SETTINGS_SUCCESS,
      GET_SECURE_LOCATION_SETTINGS_FAILURE,
    ],
  },
});

export const updateSecuredLocationSettings = (settings: ISecuredLocationSettings) => ({
  [CALL_API]: {
    endpoint: 'config/gis/secured-location-settings',
    method: 'post',
    body: settings,
    authenticated: true,
    types: [
      UPDATE_SECURE_LOCATION_SETTINGS_REQUEST,
      UPDATE_SECURE_LOCATION_SETTINGS_SUCCESS,
      UPDATE_SECURE_LOCATION_SETTINGS_FAILURE,
    ],
  },
});

export const fetchConfigGisFields = () => ({
  [CALL_API]: {
    endpoint: 'config/gis/fields',
    method: 'get',
    authenticated: true,
    types: [FETCH_CONFIG_GIS_FIELDS_REQUEST, FETCH_CONFIG_GIS_FIELDS_SUCCESS, FETCH_CONFIG_GIS_FIELDS_FAILURE],
  },
});

export const saveConfigGisMapping = (address: string, mapping: IGISMappingReqObject) => ({
  [CALL_API]: {
    endpoint: 'config/gis/mapping',
    method: 'put',
    body: { address, mapping },
    authenticated: true,
    types: [SAVE_CONFIG_GIS_MAPPING_REQUEST, SAVE_CONFIG_GIS_MAPPING_SUCCESS, SAVE_CONFIG_GIS_MAPPING_FAILURE],
  },
});

export const fetchConfigGisMapping = () => ({
  [CALL_API]: {
    endpoint: 'config/gis/mapping',
    method: 'get',
    authenticated: true,
    types: [FETCH_CONFIG_GIS_MAPPING_REQUEST, FETCH_CONFIG_GIS_MAPPING_SUCCESS, FETCH_CONFIG_GIS_MAPPING_FAILURE],
  },
});
